document.addEventListener("DOMContentLoaded", function() {
    var targetNode = document.querySelector('.shopify-section.cc-apps.section');
    var config = { childList: true, subtree: true, autocomplete: false };

    var callback = function(mutationsList, observer) {
        for (var mutation of mutationsList) {
            if (mutation.type === 'childList') {
                if(document.querySelector('.ais-h2')){
                  if(document.querySelector('.ais-h2').textContent.trim() == 'Search result'){
                    document.querySelector('.ais-h2').innerHTML = 'Search'
                  }
                }
              
                // if(document.querySelectorAll('.ais-facet-dropdown-wrapper').length > 0){
                //   const element = document.querySelectorAll('.ais-facet-dropdown-wrapper');

                //   element.forEach((item, index)=>{
                //     if(item.querySelector('[for="meta.custom.other_benefits"]')){
                //       const divs = item.querySelectorAll('li');

                //       divs.forEach((div, num)=>{
                //         div.innerHTML = `<span>${div.textContent.trim().match(/"([^"]*)"/)[1]}</span>`
                //       })
                //     }
                //   })
                // }
            }
        }
    };

    var observer = new MutationObserver(callback);
    if (targetNode) {
        observer.observe(targetNode, config);
    } else {
        console.error('targetNode not found. Make sure "predictive-search" exists in the DOM.');
    }
});

